/**
 * Created by RKL on 21/08/2015.
 */
define('offersMain',[
  'module',
  'logger',
  'offersMainRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var Offers = {
    start: function() {
      Logger.log(module, 'starting OffersModule');
    },

    stop: function() {
      Logger.log(module, 'stopping OffersModule');
      $('#customer-comments-sidebar-region').hide();
    }
  };

  module.exports = Offers;
});
